export default {
  noname: "El campo Nombre es obligatorio",
  nophone: "El campo Teléfono es obligatorio",
  noposition: "El campo Cargo es obligatorio",
  noemail: "El campo Email es obligatorio",
  noreport: "El fichero Informe Interno es obligatorio",
  noreportfile: "El fichero de reporte a subir es obligatorio",
  nomeeting: "El fichero Acta del Consejo es obligatorio",
  nostatement: "El fichero Declaración del Secretario es obligatorio",
  noauditor: "El campo Auditora es obligatorio",
  noreportdate: "El campo Fecha del Informe es obligatorio con el formato correcto (dd/mm/yyyy)",
  noreportdateincludedinperiod: "El campo Fecha del Informe tiene que estar entre el 1 de enero del año actual y la fecha de entrega",
  noaccounts: "El fichero Cuentas Anuales es obligatorio",
  wrongname: "El nombre del fichero debe ser ",
  wrongextension: "El fichero debe ser un fichero excel válido. Tiene que acabar en xlsx"
};
